import { Alert, Badge, Group, Text } from "@mantine/core";
import { IconSparkles } from "@tabler/icons-react";

/**
 * Props for the ExtractedDataHint component.
 * @agentic connections
 */
type ExtractedDataHintProps = {
  label: string;
  values: string[];
  description?: string;
};

/**
 * Displays raw crawled data from website import above form fields
 * that require manual matching, enabling easy copy/paste.
 * @agentic connections
 */
export const ExtractedDataHint = ({
  label,
  values,
  description = "Please select the matching items in the field below.",
}: ExtractedDataHintProps) =>
  values.length > 0 ? (
    <Alert
      icon={<IconSparkles size={14} />}
      color="grape"
      variant="light"
      py="xs"
      mt="md"
      mb="xs"
    >
      <Text size="xs" fw={500} mb={2}>
        {label}
      </Text>
      <Text size="xs" c="dimmed" mb={4}>
        {description}
      </Text>
      <Group gap={4} wrap="wrap">
        {values.map((v) => (
          <Badge
            key={v}
            variant="dot"
            color="grape"
            size="sm"
            style={{ cursor: "text", userSelect: "text" }}
          >
            {v}
          </Badge>
        ))}
      </Group>
    </Alert>
  ) : null;
